<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本参数配置" name="first">
      </el-tab-pane>
      <el-tab-pane label="其他配置" name="second">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: "CardDict",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
  },
  created() {
  },
};
</script>